import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ADDRESS_0X0 } from "@gearbox-protocol/sdk/onchain";
import clsx from "clsx";
import { memo } from "react";
import { CopyToClipboard } from "../elements";
import { EtherscanLogo } from "../icons";
export const AddressView = memo(props => {
    const { address, compact, className, hideEtherscan, network } = props;
    const addr = compact
        ? address.slice(0, 5) +
            "..." +
            address.slice(address.length - 3, address.length)
        : address;
    return (_jsxs("div", { className: clsx("flex flex-row items-center", className), children: [_jsx("pre", { className: "font-mono mr-2", children: addr }), address !== ADDRESS_0X0 && (_jsxs(_Fragment, { children: [!hideEtherscan && (_jsx(EtherscanLogo, { address: address, network: network, className: "mr-2" })), _jsx(CopyToClipboard, { text: address })] }))] }));
});
AddressView.displayName = "Address";
